import AnimatedPage from './AnimatedPage';

/*
    Animation des pages Agence.
*/
class Agence extends AnimatedPage{
    constructor(){
        super(200);

        this.showPage();
        this._initScroll();
        this._opacityCover();

    }

    showPage(){
        let $h1 = $('.Cover h1'),
            $accroche = $('.Cover-accroche'),
            $coverImg = $('.Cover-img'),
            $firstVisuel = $('.Slice-firstVisuel')
        ;



        let tl = new TimelineLite()
        .fromTo($coverImg,1,{scale:1,autoAlpha:0},{scale:1.3,autoAlpha:1,ease:Power4.easeOut})
        .fromTo($h1, 0.7, {y:60, autoAlpha:0}, {y:0, autoAlpha:1, ease:Power4.easeInOut},0)
        .fromTo($accroche,.3,{y:30,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},.5)
        .add(this.showHeader(),.5)
        .fromTo($firstVisuel,1,{y:30,autoAlpha:0},{y:0,autoAlpha:1,ease:Power4.easeOut},.6)
    }

    _getAnimatedElement(){
       return $('.SiteHeader,.Slice');
    }

    _getAnimatedElements(){
        return [
            {$el:$('.Slice'), fn:this._showSlice}
        ];
    }

    _showSlice(el){
        let $visuel = $('.Slice-visuel',el),
            $wysiwig = $('.Slice-wysiwyg',el),
            tl = new TimelineLite()
        ;

        tl.fromTo($visuel,.7,{y:80,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut})
        if($wysiwig.length){
            tl.fromTo($wysiwig,.7,{y:80,autoAlpha:0},{y:0,autoAlpha:1,force3D:true,ease:Power4.easeOut},0)
        }
    }

    _opacityCover(){
          var scroll,
              targetScroll = 0,
              currentScroll = 0,
              jparalax = $('.parallax'),
              jDocument = $(document),
              $coverImg = $('.Cover-img img'),
              $h = $coverImg.height(),
              $this = this
          ;

          let 	opacityMin = 0,
                opacityMax = $coverImg.attr('data-opacity')/100,
                scrollMin = 0,
                scrollMax = $(window).height(),
                scrollRatio,
                opacityRatio,
                percent
         ;


          // parallax //
          $(window).scroll(function(e) {
              scroll = $(window).scrollTop();
              scrollRatio = scroll/scrollMax,
              opacityRatio = opacityMax - (opacityMax/(opacityMax - opacityMin) * scrollRatio);

                if(opacityRatio < opacityMin){
                    opacityRatio = opacityMin;
                }else if(opacityRatio > 1){
                    opacityRatio = opacityMax;
                }
                percent = scrollRatio*100;

                $coverImg.css({
                    'opacity': opacityRatio,
                    'filter':`grayscale(${percent*2}%)`
                });
          });

      }
}
export default Agence;
